<template>
  <div class="content">
    <div class="home" v-if="showHome">
      <div class="heard">
        <el-tabs class="paTabs" v-model="activeName" @tab-click="handleClick">
          <!--          <el-tab-pane label="今日优惠管理" name="one"></el-tab-pane>-->
          <!--          <el-tab-pane label="新品展示管理" name="two"></el-tab-pane>-->
          <!--          <el-tab-pane label="爆款专区管理" name="three"></el-tab-pane>-->
          <!--          <el-tab-pane label="新人专享管理" name="four"></el-tab-pane>-->
          <!--          <el-tab-pane label="团购专区管理" name="seven"></el-tab-pane>-->
          <!--          <el-tab-pane label="好物推荐管理" name="five"></el-tab-pane>-->
          <!--          &lt;!&ndash; <el-tab-pane label="限时秒杀管理" :name="9"></el-tab-pane> &ndash;&gt;-->
          <!--          <el-tab-pane label="砍价管理" name="eight"></el-tab-pane>-->
          <!--          <el-tab-pane label="会员专区" name="six"></el-tab-pane>-->

          <el-tab-pane v-for="(item, index) in tabNameList" :key="index" :label="item.name"
                       :name="item.value"></el-tab-pane>

        </el-tabs>
<!--        <el-row v-if="activeTabNum == 8" :gutter="10">-->
<!--          <el-tabs v-model="bargainTab" @tab-click="handleBargainClick">-->
<!--            <el-tab-pane label="砍价商品" name="1"></el-tab-pane>-->
<!--            <el-tab-pane label="砍价列表" name="2"></el-tab-pane>-->
<!--          </el-tabs>-->
<!--        </el-row>-->

        <el-form ref="form" :model="querySearch.condition" label-width="80px">

          <div class="" v-if="bargainTab == '2'">
            <el-row>
              <el-col :span="10">

                <el-form-item label="砍价时间:">
                  <el-date-picker @change="changeTime" v-model="forceTime" type="datetimerange" range-separator="至"
                                  start-placeholder="开始日期" end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm"
                                  :default-time="['', '23:59:00']" class="custom-date-picker" format="yyyy-MM-dd HH:mm"
                                  style="width: 100%;">
                  </el-date-picker>
                </el-form-item>

              </el-col>
              <el-col :span="8">

                <el-form-item label="砍价状态:">
                  <el-select v-model="querySearch.condition.status" placeholder="请选择" style="width: 80%">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="进行中" :value="1"></el-option>
                    <el-option label="已付款" :value="2"></el-option>
                    <el-option label="已失效" :value="3"></el-option>
                  </el-select>

                </el-form-item>

              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <el-row>
              <el-col :span="9">

                <el-form-item label="活动时间:">
                  <el-date-picker @change="changeTime" v-model="forceTime" type="datetimerange" range-separator="至"
                                  start-placeholder="开始日期" end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  :default-time="['', '23:59:59']" style="width: 100%;">
                  </el-date-picker>
                </el-form-item>

              </el-col>

              <el-col :span="5">

                <el-form-item label="商品名称:">
                  <el-input clearable v-model="querySearch.condition.productName"
                            placeholder="请输入商品名称"></el-input>
                </el-form-item>
              </el-col>

              <!--              <el-col :span="5">-->
              <!--                <el-form-item label="活动状态:">-->
              <!--                  <el-select clearable v-model="querySearch.condition.productStatus" placeholder="请选择" style="width: 100%">-->
              <!--                    <el-option label="全部" :value="null"></el-option>-->
              <!--                    <el-option label="上架" :value="1"></el-option>-->
              <!--                    <el-option label="下架" :value="2"></el-option>-->
              <!--                  </el-select>-->

              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-col :span="4" style="margin-left: 20px; width: 160px;">
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
              </el-col>

            </el-row>

          </div>
        </el-form>
      </div>
      <div v-if="bargainTab == '2'" class="main">
        <div class="main-table">
          <el-table v-loading="loading" :data="tableList" style="width: 100%" border height="60vh">
            <el-table-column label="序号" type="index" width="70" align="center">
            </el-table-column>
            <el-table-column prop="memberLogo" label="头像" width="100" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.memberLogo" style="width: 50px; height: 50px;" :src="scope.row.memberLogo"
                          :preview-src-list="[scope.row.memberLogo]" fit="contain">
                  <div slot="error" class="image_err-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div v-else>暂无图片</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="memberCode" label="用户id" width="100" align="center">-->
<!--            </el-table-column>-->
            <el-table-column prop="memberName" label="用户昵称" width="100" align="center">
            </el-table-column>
            <el-table-column prop="bargainAmount" label="砍价金额" width="100" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="砍价时间" width="280" align="center">
              <!-- <template slot-scope="{ row }">
                <span>{{ row.startTime }}~{{ row.endTime }}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="productName" label="砍价商品" width="160" align="center">
            </el-table-column>
            <el-table-column prop="bargainMinPrice" label="最低价" width="100" align="center">
            </el-table-column>
            <el-table-column prop="nowPrice" label="当前价" width="100" align="center">
            </el-table-column>
<!--            <el-table-column prop="nowTimes" label="总砍价次数" width="100" align="center">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="bargainTimes" label="剩余砍价次数" width="100" align="center">-->
<!--              <template slot-scope="{ row }">-->
<!--                <span>{{ Number(row.bargainTimes) - Number(row.nowTimes) || 0 }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="endTime" label="结束时间" width="180" align="center">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="130" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.status == 1" type="success" plain>进行中</el-button>
                <el-button v-if="row.status == 2" type="success" plain>已付款</el-button>
                <el-button v-if="row.status == 3" type="warning" plain>已失效</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination background layout="total, prev, pager, next" :total="count" :page-size="10"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
      <div v-else class="main">
        <div class="add-box">
          <el-button type="primary" plain style="font-size: 16px" @click="addGoods">新增</el-button>
          <div style="margin: 0 20px;">
            活动状态：
            <el-switch @change="changeStatus(1)" active-value="1" inactive-value="0" v-model="isStatus"></el-switch>
          </div>
          <div>
            是否上热搜推荐：
            <el-switch @change="changeStatus(2)" active-value="1" inactive-value="0" v-model="isSearch"></el-switch>
          </div>
        </div>
        <div class="main-table">
          <el-table v-loading="loading" :data="tableList" style="width: 100%" border ref="multipleTable">
            <!--            <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" width="150" align="center">
            </el-table-column>
            <el-table-column prop="name" label="活动时间" width="280" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.startTime }}~{{ row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="saleVolume" label="已售销量" width="100" align="center">
            </el-table-column>
            <el-table-column prop="stock" label="剩余库存" width="100" align="center">
            </el-table-column>
            <el-table-column prop="sort" label="商品排序" width="100" sortable align="center">
            </el-table-column>
            <el-table-column prop="status" label="商品状态" width="130" align="center">
              <template slot-scope="{ row }">

                <el-button v-if="row.productStatus == 1" type="success" plain>上架</el-button>
                <el-button v-else-if="row.productStatus == 2" type="warning" plain>下架</el-button>
              </template>
            </el-table-column>
<!--            &lt;!&ndash; 是否上热搜 0否 1是 &ndash;&gt;-->
<!--            <el-table-column prop="isHot" label="热搜推荐" width="100" align="center">-->
<!--              <template slot-scope="{ row }">-->
<!--                <el-button v-if="row.recommendStatus == 1" type="success" plain>是</el-button>-->
<!--                <el-button v-else type="warning" plain>否</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="creator" label="创建人" width="100" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" align="center">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="{ row }">
                <div>
                  <el-button type="text" size="small" @click="editProduct(row)">编辑</el-button>
                  <el-button type="text" size="small" @click="copyProduct(row)">复制</el-button>
                  <el-button type="text" size="small" @click="delProduct(row)" style="color: red;">删除</el-button>
                  <el-button type="text" size="small" @click="editSort(row)" style="color: red;">商品排序</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination background layout="total, prev, pager, next" :total="count" :page-size="10"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-if="!showHome">
      <addGoodPage @goBack="goBack" :activeTabNum="activeTabNum" :parentId="parentId"></addGoodPage>
    </div>

    <el-dialog title="商品排序" :visible.sync="dialogFormVisible">
      <el-form ref="sortFrom" :model="form" :rules="rules">
        <el-form-item label="排序" label-width="60px" prop="sort">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import addGoodPage from './components/addGoodPage.vue'

export default {
  components: {
    addGoodPage
  },

  data () {
    var sortValidator = (rule, value, callback) => {
      console.log(value, 257)
      if (!value) {
        return callback(new Error('排序内容不能为空'))
      }
      // 使用正则表达式验证整数且在1到100之间
      const regex = /^(?:[1-9][0-9]?|100)$/ // 1 到 100 的正则表达式

      if (!regex.test(value)) {
        return callback(new Error('请输入1到100之间的整数'))
      }
      callback()
    }
    return {
      parentId: '',
      showHome: true,
      activeName: '1',
      activeTabNum: 1,
      value1: '',
      value: '',
      forceTime: [],
      querySearch: {
        condition: {
          startTime: '',
          endTime: '',
          productCode: '',
          productName: '',
          status: ''
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      tableList: [],
      count: 0,
      loading: false,
      bargainTab: '1',
      btnloading: false,
      activeState: true,
      recommendState: true,
      multipleSelection: [],
      dialogFormVisible: false,
      tabNameList: [
        {
          name: '今日优惠管理',
          value: '1'
        },
        {
          name: '新品展示管理',
          value: '2'
        },
        {
          name: '爆款专区管理',
          value: '3'
        },
        {
          name: '新人专享管理',
          value: '4'
        },
        {
          name: '好物推荐管理',
          value: '5'
        },
        {
          name: '会员管理',
          value: '6'
        },
        {
          name: '团购专区管理',
          value: '7'
        },
        {
          name: '砍价专区',
          value: '8'
        }
      ],
      isStatus: 0,
      isSearch: 0,
      statusInfo: {},
      form: {
        sort: ''
      },
      obj: {},
      rules: {
        sort: [
          { validator: sortValidator, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getProductActivity()
  },
  methods: {
    // updateStatus() {
    //   let ids = this.multipleSelection.map(item => item.id)
    //   let params = {
    //     list: ids,
    //     productStatus: this.activeState ? 1 : 2,
    //     recommendStatus: this.recommendState ? 1 : 2
    //   }
    //   const _url = this.bargainTab == '2' ? '/memberBargain/list' : '/productActivity/updateBatch'
    //   this.$http.post(_url, params).then(res => {
    //     if (res.data.code === 200) {
    //       this.$message({
    //         message: "操作成功！",
    //         type: "success",
    //       });
    //       this.getProductActivity();
    //     } else {
    //       this.$message.error(res.data.message);
    //     }
    //   })
    // },
    editProduct (row) {
      this.parentId = row.id
      this.showHome = false
    },
    copyProduct (row) {
      if (this.btnloading) {
        return
      }
      this.btnloading = true
      this.$confirm('确认复制该条数据吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .post('/productActivity/copyProductActivity', {
            activityCode: row.activityCode
          })
          .then((res) => {
            console.log(res)
            if (res.data.code === 200) {
              this.$message({
                message: '复制成功！',
                type: 'success'
              })
              this.search()
            }
            this.btnloading = false
          }).catch(err => {
            this.btnloading = false
          })
      })
    },
    changeTime (data) {
      if (data) {
        this.querySearch.condition.startTime = data[0]
        this.querySearch.condition.endTime = data[1]
      } else {
        this.querySearch.condition.startTime = ''
        this.querySearch.condition.endTime = ''
      }
      // this.getProductActivity();
    },

    editSort (item) {
      this.form.sort = item.sort
      this.obj = item
      this.dialogFormVisible = true
    },

    saveSort () {
      this.$refs['sortFrom'].validate(async (valid) => {
        if (valid) {
          this.obj.sort = this.form.sort
          const res = await this.$http.post('productActivity/update', this.obj)
          if (res.data.code === 200) {
            this.$message.success('修改成功')
            this.dialogFormVisible = false
            await this.getProductActivity()
          } else {
            this.$message.error(res.data.message)
          }
        } else {
          console.log('error', valid)
        }
      })
    },

    handleCurrentChange (val) {
      this.querySearch.currPage = val
      this.getProductActivity()
    },
    search () {
      this.querySearch.currPage = 1
      this.getProductActivity()
    },
    reset () {
      this.querySearch.condition = {}
      this.forceTime = []
      this.querySearch.currPage = 1
      this.querySearch.pageSize = 10
      this.getProductActivity()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    addGoods () {
      this.showHome = false
    },
    async handleClick (tab) {
      this.bargainTab = '1'

      this.activeTabNum = tab.name

      this.$nextTick(() => {
        this.loading = true
        this.getProductActivity()
      })
    },
    handleBargainClick () {
      this.$nextTick(() => {
        this.loading = true
        this.search()
      })
    },
    async getProductActivity () {
      this.loading = true
      this.querySearch.condition.activityType = this.activeTabNum

      const url = this.bargainTab == '2' ? '/memberBargain/list' : '/productActivity/listAll'
      const res = await this.$http.post(url, this.querySearch)

      if (res.data.code === 200) {
        this.tableList = res.data.data.data
        this.count = res.data.data.count
        this.loading = false

        const res2 = await this.$http.post('systemConfig/queryOne', {
          propertyIndex: this.activeTabNum,
          systemId: '1000'
        })
        if (res2.data.code === 200) {
          this.statusInfo = res2.data.data
          this.isStatus = res2.data.data.propertyValue.split(',')[0]
          this.isSearch = res2.data.data.propertyValue.split(',')[1]
          console.log(this.isStatus, this.isSearch)
        }
      }
    },
    async changeStatus (val) {

      if(this.isStatus == 0){
        this.isSearch = 0
      }

      let propertyValue = this.isStatus + ',' + this.isSearch
      this.statusInfo.propertyValue = propertyValue
      console.log(this.statusInfo)
      const res = await this.$http.post('systemConfig/update', this.statusInfo)

      if(res.data.code === 200) {
        if(val===1){
          this.isStatus == 1 ? this.$message.success("活动上架成功") :this.$message.success("活动下架成功")
        }

        if(val===2){
          this.isSearch == 1 ? this.$message.success("该活动已上热搜") :this.$message.success("该活动已下热搜")
        }

        //
      }

    },
    delProduct (row) {
      let _this = this
      this.$confirm('确认删除该条数据吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$http
          .post('/productActivity/delete', {
            id: row.id,
            activityCode: row.activityCode
          })
          .then((res) => {
            console.log(res)
            if (res.data.code === 200) {
              _this.$message({
                message: '删除成功！',
                type: 'success'
              })
              _this.getProductActivity()
            }
          })
      })
    },
    goBack () {
      this.parentId = ''
      this.showHome = true
      this.getProductActivity()
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  height: 100% !important;

  .home {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    background-color: #eef1f6;
    padding: 10px;
    box-sizing: border-box;
  }

  .heard {
    background-color: #fff;
    height: auto;
    padding: 10px;

    .item-col {
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      .label {
        width: fit-content;
        margin-right: 10px;
      }

      div {
        flex: 1;
      }
    }
  }

  .add-box {
    display: flex;
    align-items: center;
  }

  .main {
    margin-top: 20px;
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .main-table {
      flex: 1;
      overflow: hidden;
    }

    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}

/deep/ .paTabs .el-tabs__nav-wrap::after {
  position: static !important;
}

/deep/ .paTabs .el-tabs__active-bar {
  background-color: transparent !important;
}

/deep/ .paTabs .el-tabs__nav.is-top {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  background-color: #dff0f9;
}

::v-deep .el-button {
  font-size: 13px;
  text-align: center;
  height: 30px;
  line-height: 1;
  padding: 0 10px;
}
</style>
